import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0,1919.88709 L1467.87912,1919.88709 L1467.87912,452.007969 L0,452.007969 L0,1919.88709 Z M1354.96534,564.921747 L1354.96534,1806.97331 L112.913778,1806.97331 L112.913778,564.921747 L1354.96534,564.921747 Z M1920,0 L1920,1467.99203 L1581.25867,1467.99203 L1581.25867,1354.96534 L1807.08622,1354.96534 L1807.08622,112.913778 L565.034661,112.913778 L565.034661,338.741335 L452.007969,338.741335 L452.007969,0 L1920,0 Z M338.741335,1016.92972 L1129.13778,1016.92972 L1129.13778,904.015937 L338.741335,904.015937 L338.741335,1016.92972 Z M338.741335,1467.99203 L1129.13778,1467.99203 L1129.13778,1354.96534 L338.741335,1354.96534 L338.741335,1467.99203 Z M338.741335,1242.40442 L903.310226,1242.40442 L903.310226,1129.49064 L338.741335,1129.49064 L338.741335,1242.40442 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCopyLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCopyLine, _Component);

  var _super = _createSuper(IconCopyLine);

  function IconCopyLine() {
    _classCallCheck(this, IconCopyLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCopyLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCopy",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCopyLine.displayName = "IconCopyLine";
  return IconCopyLine;
}(Component);

IconCopyLine.glyphName = 'copy';
IconCopyLine.variant = 'Line';
IconCopyLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCopyLine;
export { IconCopyLine };